import React from 'react';
import classNames from 'classnames';
import { HudIcon, IconType } from '../../../Icons/HudIcons';

import { Container } from './Pills.styles';
import Tooltip from '../Tooltip/Tooltip';

export interface PillItem {
  id: string;
  label: string;
  warningTooltip?: string;
}

export interface PillsProps {
  prefixIcon?: IconType;
  items: PillItem[];
  'aria-label'?: string;
  'aria-describedby'?: string;
}

export const Pills: React.FC<PillsProps> = ({
  items,
  prefixIcon,
  'aria-label': ariaLabel = 'Selected items',
  'aria-describedby': ariaDescribedBy,
}) => {
  return (
    <Container role="list" aria-label={ariaLabel} aria-describedby={ariaDescribedBy}>
      {prefixIcon && <HudIcon className="prefix-icon" icon={prefixIcon} size="16px" />}
      {items.map((item) => {
        const hasWarning = item.warningTooltip?.length;

        return (
          <div
            className={classNames('pill-item', { 'has-warning': hasWarning })}
            key={item.id}
            role="listitem"
            aria-label={`${item.label}${hasWarning ? `: ${item.warningTooltip}` : ''}`}
          >
            <span>{item.label}</span>
            {hasWarning && (
              <Tooltip label={item.warningTooltip || ''}>
                <div className="info-icon-container">
                  <HudIcon
                    icon="designSystem.infoCircle"
                    size="12px"
                    aria-label="Warning indicator"
                  />
                </div>
              </Tooltip>
            )}
          </div>
        );
      })}
    </Container>
  );
};
